import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEditSmall1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEditSmall1"><Path d="M11.5 3.5H3.5V20.5H20.5V12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 11.5V8.5L18.5 2.5L21.5 5.5L15.5 11.5H12.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconEditSmall1;
